import { Directive } from '@angular/core';
import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EngService } from '../services/eng.service';

export function uniqueMapNumberValidator(engService: EngService): AsyncValidatorFn {
  return (c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    if (!c.value) {
      return of(null);
    }
    const engagementData = JSON.parse(localStorage.getItem('selectedEngagementObj'));
    return engService.validateMapNumber(engagementData.engagementsid, c.value).pipe(
      map(res => {
        if (res.status === 200) {
          return null;
        } else {
          return {'uniqueMapno': true};
        }
      }),
      catchError(() => of({'uniqueMapno': true}))
    );
  };
}

@Directive({
  selector: '[uniqueMapno][formControlName],[uniqueMapno][formControl],[uniqueMapno][ngModel]',
  providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: UniqueMapNumberValidatorDirective, multi: true}],
  standalone: false
})
export class UniqueMapNumberValidatorDirective implements AsyncValidator {
  constructor(private engService: EngService) { }

  validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return uniqueMapNumberValidator(this.engService)(c);
  }
}
